import { render, staticRenderFns } from "./carbonSinkResources.vue?vue&type=template&id=cec9c484&scoped=true"
import script from "./carbonSinkResources.vue?vue&type=script&lang=js"
export * from "./carbonSinkResources.vue?vue&type=script&lang=js"
import style0 from "./carbonSinkResources.vue?vue&type=style&index=0&id=cec9c484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec9c484",
  null
  
)

export default component.exports